// frontend/src/landing/sections/ProblemSection.tsx
import Card from "../components/Card";
import Section from "../components/Section";

export default function ProblemSection() {
  return (
    <Section id="ausgangslage" eyebrow="Status Quo" title="Warum Planung anspruchsvoll ist">
      <p className="zg-text">
        Jede Organisation folgt ihren eigenen Vorgaben, Gewohnheiten und Zielen.
        Die eigentlichen Regeln sind historisch gewachsen, werden mündlich weitergegeben und selten systematisch hinterfragt.
      </p>
      <p className="zg-text">
        Konventionelle Planungstools reagieren auf neue Anforderungen mit zusätzlichen Funktionen.
        So entstehen komplexe Systeme, die erst gelernt werden müssen und dennoch nie exakt passen.
      </p>
      <p className="zg-text">
        Planung bleibt aufwendig und wird zur Abstimmung von Einzelfällen.
      </p>

      <div className="zg-cards">
        <Card title="Komplexe Realität">
          <ul className="zg-list">
            <li>Ziele konkurrieren</li>
            <li>Anforderungen ändern sich</li>
            <li>Regeln nur im Kopf Einzelner</li>
          </ul>
        </Card>

        <Card title="Komplexe Software">
          <ul className="zg-list">
            <li>Feature auf Feature</li>
            <li>Menüs, Handbücher, Schulungen</li>
            <li>Programm muss „bedient“ werden</li>
          </ul>
        </Card>

        <Card title="Komplexe Abstimmung">
          <ul className="zg-list">
            <li>Ständiger Neustart</li>
            <li>Diskussionen um Details</li>
            <li>„laut“ schlägt „fair“</li>
          </ul>
        </Card>
      </div>
      <p className="zg-footnote">
        Komplexe Planung braucht keine Vereinfachung.
        Sie braucht Struktur.
      </p>
    </Section>
  );
}